import type { ReserveConfig } from '../types';
import { ARARIBOIA_BOUNDARY_FULL, ARARIBOIA_CENTER } from './arariboia_boundary_full';

/**
 * Arariboia Indigenous Reserve configuration
 * Full accuracy boundary (3623 points)
 * Area: 413,288.05 hectares
 */
export const ARARIBOIA_CONFIG: ReserveConfig = {
  center: ARARIBOIA_CENTER,
  boundary: ARARIBOIA_BOUNDARY_FULL,
  gridSize: 0.1 // 100m x 100m = 1 hectare
};

/**
 * Sample historical BQI data for time slider
 */
export const HISTORICAL_DATA = [
  {
    date: '2024-01',
    avgBQI: 72.3,
    totalSpecies: 1245
  },
  {
    date: '2024-04',
    avgBQI: 74.8,
    totalSpecies: 1289
  },
  {
    date: '2024-07',
    avgBQI: 76.2,
    totalSpecies: 1312
  },
  {
    date: '2024-10',
    avgBQI: 78.5,
    totalSpecies: 1356
  },
  {
    date: '2025-01',
    avgBQI: 79.1,
    totalSpecies: 1378
  },
  {
    date: '2025-04',
    avgBQI: 80.3,
    totalSpecies: 1402
  },
  {
    date: '2025-07',
    avgBQI: 81.7,
    totalSpecies: 1435
  },
  {
    date: '2025-10',
    avgBQI: 82.9,
    totalSpecies: 1467
  }
];
